/* eslint-disable react-refresh/only-export-components */

import {
  useMemo,
  useContext,
  createContext,
  FC,
  PropsWithChildren,
  useReducer,
} from 'react';

import _dayjs, { ConfigType } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';

_dayjs.extend(utc);
_dayjs.extend(timezone);
_dayjs.extend(isBetween);
_dayjs.extend(duration);
_dayjs.extend(relativeTime);
_dayjs.extend(isToday);
// _dayjs.tz.setDefault(import.meta.env.VITE_APP_TIMEZONE);

export const dayjs = (date?: ConfigType, format?: string) => {
  return _dayjs.tz(_dayjs(date, format));
};

// USE FOR PAYLOADS (EX: CALENDAR, BOOKING)
export const payloadDayjs = (
  date?: ConfigType,
  format?: string,
  timezone?: string,
) => _dayjs.tz(date, `${format} HH:mm`, timezone).toISOString();

const TYPE = ['setTimezone'] as const;

interface DISPATCH_REDUCER {
  type: (typeof TYPE)[number];
  payload: Record<string, any>;
}

interface CONTEXT {
  state: STATE;
  dispatch?: React.Dispatch<DISPATCH_REDUCER>;
}

/**
 * @deprecated Use `useTimezoneProviderContext` from `timezone.provider.tsx` instead.
 */
export const TimezoneContext = createContext({ state: {} });

/**
 *
 * @deprecated Use `useTimezoneProviderContext` from `timezone.provider.tsx` instead.
 */
export const useTimezoneContext = () => useContext(TimezoneContext) as CONTEXT;

interface STATE {
  timezone: string;
}
const Reducer = (state: STATE, { type, payload }: DISPATCH_REDUCER): STATE => {
  if (type === 'setTimezone') {
    if (payload?.timezone) {
      _dayjs.tz.setDefault(payload.timezone);
    }

    return {
      ...state,
      timezone: payload?.timezone || state.timezone,
    };
  }

  return state;
};

/**
 * @deprecated Use `TimezoneProvider` from `timezone.provider.tsx` instead.
 */
const Timezone: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, {
    timezone: import.meta.env.VITE_APP_TIMEZONE,
  });

  const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

  return (
    <TimezoneContext.Provider value={value}>
      {children}
    </TimezoneContext.Provider>
  );
};

export default Timezone;
